// eslint-disable-next-line import/prefer-default-export
export const LANGUAGES = {
  ru: 'ru',
};
